import React from 'react';
import Testimonials from 'js/components/Templates/Services/Testimonials/Testimonials';
import ServicesOfferings from 'js/components/Templates/Services/ServicesOfferings/ServicesOfferings';
import SuccessStories from 'js/components/Templates/Services/SuccessStories/SuccessStories';
import PlaytechServices from 'js/components/Templates/Services/PlaytechServices/PlaytechServices';
import ServicesForm from 'js/components/Templates/Services/ServicesForm/ServicesForm';
import ServicesWrap from 'js/components/Templates/Services/ServicesWrap/ServicesWrap';


const ServicesTemplate = ({ pageId }) => (
	<main className="templateServices">
        <ServicesWrap>
            <PlaytechServices pageId={pageId} />
            <ServicesOfferings pageId={pageId} />
        </ServicesWrap>
        <Testimonials pageId={pageId} />
        <SuccessStories pageId={pageId} />
		<ServicesForm pageId={pageId} />
	</main>
);

export default ServicesTemplate;
